import { Moon, Sun } from "lucide-react";
import clsx from "clsx";
import { useThemeStore } from "../../lib/stores/theme";

export function ThemeToggle({ forceDark = false }: { forceDark?: boolean }) {
  const { resolvedTheme, toggleTheme } = useThemeStore();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label="Toggle theme"
      className={clsx(
        "h-11 w-11 rounded-full flex items-center justify-center transition-colors duration-300 ease-physical active:scale-95",
        forceDark
          ? "text-[#f6f1e7]/70 hover:text-[#f6f1e7] hover:bg-white/10"
          : "text-ink-muted hover:text-ink hover:bg-surface"
      )}
    >
      {resolvedTheme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
}
